import React from 'react';
import { Dog, Check, MapPin, Heart, Camera, PartyPopper, Star, Users } from 'lucide-react';

// Images
const TOBY_IMAGE = "https://customer-assets.emergentagent.com/job_tradie-leads-1/artifacts/92iyvmuc_Tobi%20CBO%20Puppoto.jpg";

const PuppotoBusinessCards = () => {
  return (
    <div className="min-h-screen bg-gray-100 py-12 px-4">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold text-center mb-2">Puppoto Business Cards</h1>
        <p className="text-center text-gray-600 mb-8">Print-ready designs - Right-click to save or use Print function</p>
        
        {/* Card 1: Business Partners */}
        <div className="mb-16">
          <h2 className="text-xl font-bold mb-4 text-gray-800">Card 1: Business Partners / Sponsors</h2>
          <p className="text-sm text-gray-500 mb-4">QR Code URL: https://puppoto.com/puppoto/partners-invite</p>
          
          <div className="flex flex-col md:flex-row gap-4 justify-center">
            {/* Front */}
            <div className="w-[350px] h-[200px] bg-gradient-to-br from-slate-800 via-slate-900 to-slate-800 rounded-xl shadow-2xl p-6 flex flex-col justify-between relative overflow-hidden">
              <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-orange-500/20 to-transparent rounded-full -translate-y-1/2 translate-x-1/2" />
              
              <div className="flex items-center gap-2">
                <img src={TOBY_IMAGE} alt="Toby" className="w-10 h-10 rounded-full border-2 border-orange-400" />
                <div>
                  <div className="text-white font-bold text-lg">PUPPOTO</div>
                  <div className="text-gray-400 text-xs">Australia's #1 Dog Social Platform</div>
                </div>
              </div>
              
              <div className="flex items-center gap-4">
                <div className="w-20 h-20 bg-white rounded-lg flex items-center justify-center">
                  <div className="text-center">
                    <div className="text-xs text-gray-500">QR CODE</div>
                    <div className="text-xs text-gray-400">HERE</div>
                  </div>
                </div>
                <div>
                  <div className="text-orange-400 font-bold text-lg">Partner With Us</div>
                  <div className="text-gray-300 text-sm">Reach 50,000+ Dog Lovers</div>
                </div>
              </div>
              
              <div className="text-gray-500 text-xs text-center">SCAN TO LEARN MORE</div>
            </div>
            
            {/* Back */}
            <div className="w-[350px] h-[200px] bg-gradient-to-br from-slate-800 via-slate-900 to-slate-800 rounded-xl shadow-2xl p-5 flex flex-col justify-between">
              <div className="text-orange-400 font-bold text-sm text-center">SPONSORSHIP OPPORTUNITIES</div>
              
              <div className="grid grid-cols-2 gap-2 text-xs">
                <div className="flex items-center gap-1 text-gray-300">
                  <Check className="w-3 h-3 text-green-400" /> Featured Listing
                </div>
                <div className="flex items-center gap-1 text-gray-300">
                  <Check className="w-3 h-3 text-green-400" /> Local Marketing
                </div>
                <div className="flex items-center gap-1 text-gray-300">
                  <Check className="w-3 h-3 text-green-400" /> Monthly Reports
                </div>
                <div className="flex items-center gap-1 text-gray-300">
                  <Check className="w-3 h-3 text-green-400" /> Verified Badge
                </div>
              </div>
              
              <div className="text-center">
                <div className="text-gray-400 text-xs mb-1">Perfect for:</div>
                <div className="text-gray-300 text-xs">Vets • Groomers • Trainers • Pet Shops • Breeders</div>
              </div>
              
              <div className="flex justify-between items-center text-xs">
                <div className="text-gray-400">puppoto.com</div>
                <div className="text-gray-500">Launching May 2026</div>
                <div className="text-gray-400">🇦🇺</div>
              </div>
            </div>
          </div>
        </div>

        {/* Card 2: Dog Owners */}
        <div className="mb-16">
          <h2 className="text-xl font-bold mb-4 text-gray-800">Card 2: Dog Owners / Public</h2>
          <p className="text-sm text-gray-500 mb-4">QR Code URL: https://puppoto.com/puppoto/join</p>
          
          <div className="flex flex-col md:flex-row gap-4 justify-center">
            {/* Front */}
            <div className="w-[350px] h-[200px] bg-gradient-to-br from-amber-50 via-orange-50 to-yellow-50 rounded-xl shadow-2xl p-6 flex flex-col justify-between border-2 border-orange-200">
              <div className="text-center">
                <div className="text-2xl font-black bg-gradient-to-r from-orange-500 to-amber-500 bg-clip-text text-transparent">
                  🐕 Love Your Doggy?
                </div>
                <div className="text-gray-600 text-sm">Find them some friends!</div>
              </div>
              
              <div className="flex items-center justify-center gap-4">
                <div className="w-20 h-20 bg-white rounded-xl shadow-md flex items-center justify-center border border-orange-200">
                  <div className="text-center">
                    <div className="text-xs text-gray-500">QR CODE</div>
                    <div className="text-xs text-gray-400">HERE</div>
                  </div>
                </div>
                <div className="text-left">
                  <div className="text-orange-600 font-semibold text-sm">Playdates</div>
                  <div className="text-orange-600 font-semibold text-sm">Park Buddies</div>
                  <div className="text-orange-600 font-semibold text-sm">New Friends</div>
                </div>
              </div>
              
              <div className="text-center text-gray-500 text-sm">
                New canine buddies just a click away! 🐾
              </div>
            </div>
            
            {/* Back */}
            <div className="w-[350px] h-[200px] bg-gradient-to-br from-amber-50 via-orange-50 to-yellow-50 rounded-xl shadow-2xl p-4 flex flex-col justify-between border-2 border-orange-200">
              <div className="flex items-center justify-center gap-2">
                <Dog className="w-6 h-6 text-orange-500" />
                <span className="font-bold text-xl text-gray-800">PUPPOTO</span>
              </div>
              <div className="text-center text-gray-500 text-xs">The Social Playground for Dogs</div>
              
              <div className="grid grid-cols-2 gap-1 text-xs">
                <div className="flex items-center gap-1 text-gray-600">
                  <Heart className="w-3 h-3 text-pink-500" /> Tinder-style matching
                </div>
                <div className="flex items-center gap-1 text-gray-600">
                  <Camera className="w-3 h-3 text-purple-500" /> Photo feeds
                </div>
                <div className="flex items-center gap-1 text-gray-600">
                  <PartyPopper className="w-3 h-3 text-yellow-500" /> Celebrations
                </div>
                <div className="flex items-center gap-1 text-gray-600">
                  <MapPin className="w-3 h-3 text-green-500" /> Local services
                </div>
              </div>
              
              <div className="text-center">
                <div className="text-orange-600 font-semibold text-sm">Join 50,000+ Dog Lovers!</div>
                <div className="text-gray-400 text-xs">FREE to Join • No Spam 🐾</div>
              </div>
              
              <div className="flex justify-between items-center text-xs text-gray-400">
                <span>puppoto.com</span>
                <span>May 2026</span>
                <span>🇦🇺 Australia</span>
              </div>
            </div>
          </div>
        </div>

        {/* Print Instructions */}
        <div className="bg-white rounded-xl p-6 shadow-lg">
          <h3 className="font-bold text-lg mb-4">How to Print</h3>
          <ol className="list-decimal list-inside space-y-2 text-gray-700">
            <li>Generate QR codes at <a href="https://www.qr-code-generator.com/" target="_blank" rel="noopener noreferrer" className="text-orange-500 hover:underline">qr-code-generator.com</a></li>
            <li>Card 1 QR: <code className="bg-gray-100 px-2 py-1 rounded text-sm">https://puppoto.com/puppoto/partners-invite</code></li>
            <li>Card 2 QR: <code className="bg-gray-100 px-2 py-1 rounded text-sm">https://puppoto.com/puppoto/join</code></li>
            <li>Take screenshots of each card above</li>
            <li>Print at 3.5" x 2" (standard business card size)</li>
            <li>Or upload to Vistaprint, MOO, or Canva for professional printing</li>
          </ol>
          
          <div className="mt-6 p-4 bg-orange-50 rounded-lg">
            <p className="text-sm text-orange-800">
              <strong>Pro Tip:</strong> Use Canva's free business card templates and add your QR codes for a polished look!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PuppotoBusinessCards;
